'use strict'

import moment from 'moment'

const filters = {
    datetime (val, format) {
        if (!val) return ''
        var f = format || 'YYYY-MM-DD HH:mm:ss'
        return moment(val).format(f)
    },
    linebreak (val,reaplce='<br />') {
        if (!val) return ''
        return val.replace(/\n/igm,reaplce)
    }
    
}
 
export default filters
